module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexbox"
  }, [_c('div', {
    staticClass: "flex-content"
  }, [_c('div', [_c('multi-select', {
    attrs: {
      "options": _vm.options,
      "selected-options": _vm.items,
      "placeholder": "select item",
      "customAttr": _vm.customAttr,
      "show-missing-options": true
    },
    on: {
      "select": _vm.onSelect
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-result"
  }, [_c('div', [_c('h4', [_vm._v("Last selected Item")]), _vm._v(" "), _c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.lastSelectItem.value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.lastSelectItem.text))])])])])]), _vm._v(" "), _c('div', [_c('h4', [_vm._v("All selected item")]), _vm._v(" "), _c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.text))])])])
  })], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("value")]), _vm._v(" "), _c('th', [_vm._v("text")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("value")]), _vm._v(" "), _c('th', [_vm._v("text")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2784e971!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sample/Multi/_WithMissing.vue
// module id = 387
// module chunks = 2